import { validateBr } from 'js-brasil';
import { maskCPF2, maskPassport } from './mask';

export function normalizeSubscriberDocument(value) {
    const normalized = maskPassport(String(value || '').trim());
    return /^\d{11}$/.test(normalized) && validateBr.cpf(normalized)
        ? maskCPF2(normalized)
        : normalized;
}

export function isValidSubscriberDocument(value) {
    const normalized = maskPassport(String(value || '').trim());
    return validateBr.cpf(value || '') || /^[A-Z0-9]{6,20}$/.test(normalized);
}